window.initWavePro = function(sectionId, barPosDesktop, barPosMobile) {

  const root = document.querySelector('.wave-pro-' + sectionId);
  if (!root) return;

  const svg = root.querySelector('.wave-pro-svg-' + sectionId);
  const textPath = root.querySelector('#wave-pro-textpath-' + sectionId);
  const content = root.querySelector('#wave-pro-content-' + sectionId);
  const path = root.querySelector('#wave-pro-path-' + sectionId);

  if (!svg || !textPath || !content || !path) return;

  if (!window.__waveRAF__) {
    window.__waveRAF__ = {
      items: new Set(),
      rafId: null,
      lastTime: 0,
      start() {
        if (this.rafId) return;
        this.lastTime = performance.now();
        this.rafId = requestAnimationFrame(this.tick.bind(this));
      },
      tick(now) {
        const delta = now - this.lastTime;
        this.lastTime = now;
        this.items.forEach(i => i.update(delta));
        this.rafId = requestAnimationFrame(this.tick.bind(this));
      }
    };
  }

  const RAF = window.__waveRAF__;

  let pathLength = 1;
  let offsetPx = 0;
  let paused = false;

  let lastWidth = window.innerWidth;
  let lastIsMobile = window.innerWidth <= 749;
  let resizeTimer = null;

  const speed = Number(root.dataset.speed) || 25;
  const direction = root.dataset.direction === 'right' ? 1 : -1;
  const pauseOnHover = root.dataset.hover === 'true';

  const SPEED_FACTOR = 0.02 * (30 / speed);

  if (pauseOnHover) {
    root.addEventListener('mouseenter', () => paused = true, { passive: true });
    root.addEventListener('mouseleave', () => paused = false, { passive: true });
  }

  function buildWave(force = false) {
    const vw = window.innerWidth;
    const isMobile = vw <= 749;

    if (!force && isMobile === buildWave._lastMobile) return;
    buildWave._lastMobile = isMobile;

    const worldWidth = Math.max(vw * 2, 2000);
    const waveLength = isMobile ? 800 : 2400;
    const amplitude = isMobile ? 60 : 180;
    const centerY = 300;

    const targetWidth = worldWidth + waveLength * 2;
    const maxSegments = isMobile ? 4 : 7;

    let d = `M0,${centerY}`;
    let x = 0;
    let count = 0;

    while (x < targetWidth && count < maxSegments) {
      d += ` C${x + waveLength * 0.17},${centerY - amplitude}
               ${x + waveLength * 0.33},${centerY - amplitude}
               ${x + waveLength * 0.5},${centerY}
               S${x + waveLength * 0.83},${centerY + amplitude}
               ${x + waveLength},${centerY}`;
      x += waveLength;
      count++;
    }

    svg.setAttribute("viewBox", `0 0 ${worldWidth} 600`);
    svg.style.width = worldWidth + "px";
    path.setAttribute("d", d);

    requestAnimationFrame(() => {
      pathLength = path.getTotalLength() || 1;
    });
  }
  buildWave._lastMobile = null;

  function applyOffset() {
    const mult = 4;
    const extra = 5;

    const offset =
      window.innerWidth <= 749
        ? (barPosMobile + extra) * mult
        : (barPosDesktop + extra) * mult;

    root.style.setProperty('--wave-offset', offset + 'px');
  }

  function fillInfinity(force = false) {
    const vw = window.innerWidth;

    let repeat = Math.ceil(vw / 280);
    repeat = Math.min(Math.max(repeat, 6), 18);

    if (!force && content.dataset.repeat == repeat) return;
    content.dataset.repeat = repeat;

    const original = content.dataset.original || content.innerHTML;
    content.dataset.original = original;

    let html = original;
    for (let i = 0; i < repeat; i++) html += original;

    content.innerHTML = html;
  }

  const instance = {
    frame: 0,
    update(delta) {
      if (paused || document.hidden) return;

      const safeDelta = Math.min(delta, 32);
      offsetPx += direction * safeDelta * SPEED_FACTOR;

      if (offsetPx <= -pathLength) offsetPx += pathLength;
      if (offsetPx >= 0) offsetPx -= pathLength;

      this.frame++;
      if (this.frame % 2 !== 0) return;

      textPath.setAttribute(
        'startOffset',
        (offsetPx / pathLength) * 100 + '%'
      );
    }
  };

  RAF.items.add(instance);
  RAF.start();

  window.addEventListener("resize", () => {
    const w = window.innerWidth;

    if (Math.abs(w - lastWidth) < 80) return;
    lastWidth = w;

    const isMobile = w <= 749;
    if (isMobile === lastIsMobile) return;
    lastIsMobile = isMobile;

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      buildWave(true);
      applyOffset();
      fillInfinity(true);
    }, 160);
  }, { passive: true });

  buildWave(true);
  applyOffset();
  fillInfinity();

  if (document.fonts) {
    document.fonts.ready.then(() => fillInfinity(true));
  }
};